import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col justify-center items-center px-4 py-12 sm:px-6 lg:px-8 overflow-hidden relative bg-white dark:bg-black text-gray-900 dark:text-gray-100" }
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-yellow-300",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_3 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-700",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_4 = { class: "mt-4 sm:mx-auto sm:w-full sm:max-w-md z-10" }
const _hoisted_5 = { class: "backdrop-blur-lg py-8 px-6 rounded-2xl bg-white/40 dark:bg-gray-800/40 shadow-lg dark:shadow-gray-900/50" }
const _hoisted_6 = {
  key: 0,
  class: "mb-5 bg-red-50 border-l-4 border-red-400 p-4 rounded-md animate-fadeIn"
}
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "ml-3" }
const _hoisted_9 = { class: "text-sm text-red-700" }
const _hoisted_10 = { class: "space-y-4" }
const _hoisted_11 = { class: "flex flex-col items-center" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "mt-5 flex justify-center"
}
const _hoisted_14 = { class: "mt-8 text-center text-xs text-gray-600 dark:text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "absolute top-4 right-4 z-20 p-2 rounded-full transition-colors duration-200 bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.theme.toggleTheme && _ctx.theme.toggleTheme(...args)))
    }, [
      (_ctx.theme.isDark.value)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[2] || (_cache[2] = [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            }, null, -1)
          ])))
        : (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[3] || (_cache[3] = [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
            }, null, -1)
          ])))
    ]),
    _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"sm:mx-auto sm:w-full sm:max-w-md z-10\" data-v-31d68a67><div class=\"mx-auto flex items-center justify-center mb-6\" data-v-31d68a67><div class=\"flex items-center p-2\" data-v-31d68a67><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-16 w-16 mr-2\" viewBox=\"0 0 24 24\" data-v-31d68a67><path d=\"M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z\" fill=\"#FFD700\" stroke=\"#FFD700\" stroke-width=\"0.5\" data-v-31d68a67></path></svg><div class=\"flex items-center\" data-v-31d68a67><span class=\"text-5xl font-bold text-[#1E90FF] drop-shadow-sm\" data-v-31d68a67>dev</span><span class=\"text-5xl font-bold text-[#32CD32] drop-shadow-sm\" data-v-31d68a67>tools</span></div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("svg", {
                    class: "h-5 w-5 text-red-400",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z",
                      "clip-rule": "evenodd"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.error), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "w-full flex items-center justify-center px-6 py-4 border border-transparent rounded-xl shadow-lg text-base font-medium text-white bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transform transition-all duration-150 ease-in-out hover:scale-[1.02] active:scale-[0.98]",
              disabled: _ctx.loading,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.initiateAuthentikSignIn && _ctx.initiateAuthentikSignIn(...args)))
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("svg", {
                class: "w-6 h-6 mr-3",
                viewBox: "0 0 24 24",
                fill: "currentColor",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z" })
              ], -1),
              _createElementVNode("span", { class: "text-lg" }, "Sign in with Authentik", -1)
            ]), 8, _hoisted_12)
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[6] || (_cache[6] = [
                _createElementVNode("svg", {
                  class: "animate-spin h-8 w-8 text-primary",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })
                ], -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, " © " + _toDisplayString(new Date().getFullYear()) + " Platform Team ", 1)
    ])
  ]))
}